/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { useEffect, useMemo } from 'react'
import { Animated, Easing } from 'react-native'
import styled from 'styled-components/native'

import { ANIMATION_USE_NATIVE_DRIVER } from 'ui/components/animationUseNativeDriver'
import { Logo } from 'ui/svg/icons/Logo'
import { AccessibleIcon } from 'ui/svg/icons/types'

export const ButtonLoadingIndicator = ({ size, color, testID }: AccessibleIcon) => {
  const animatedValue = useMemo(() => new Animated.Value(0), [])
  const spin = useMemo(
    () =>
      animatedValue.interpolate({
        inputRange: [0, 1],
        outputRange: ['0deg', '360deg'],
      }),
    [animatedValue]
  )

  useEffect(() => {
    Animated.loop(
      Animated.timing(animatedValue, {
        toValue: 1,
        duration: 1200,
        easing: Easing.linear,
        useNativeDriver: ANIMATION_USE_NATIVE_DRIVER,
      })
    ).start()
  }, [animatedValue])

  return (
    <SpinnerContainer testID={testID}>
      <Animated.View style={{ width: Number(size), transform: [{ rotate: spin }] }}>
        <Logo size={size} color={color} />
      </Animated.View>
    </SpinnerContainer>
  )
}

const SpinnerContainer = styled.View({
  alignItems: 'center',
})
